import "./SecureYourLegacy.module.css";
import ExecutiveNavigation from "@/reusable_sections/Header";
import BeginTheConversation from "./sections/BeginTheConversation";
import PrivateOfficeInformation from "./sections/PrivateOfficeInformation";
import InquiryDetails from "./sections/InquiryDetails";
import LegacyFooter from "@/reusable_sections/Footer";
export default function SecureYourLegacyPage() {
  return <div>
      <ExecutiveNavigation />
      <BeginTheConversation />
      <PrivateOfficeInformation />
      <InquiryDetails />
      <LegacyFooter />
    </div>;
}